import { cambodiaArticlesCardData } from './articles/cambodia/cambodia-articles-card-map';
import { thailandArticlesCardData } from './articles/thailand/thailand-articles-card-map';
import { vietnamArticlesCardData } from './articles/vietnam/vietnam-articles-card-map';
import { cambodiaDestinationsCardData } from './destinations/cambodia/cambodia-destinations-card-map';
import { thailandDestinationsCardData } from './destinations/thailand/thailand-destinations-card-map';
import { vietnamDestinationsCardData } from './destinations/vietnam/vietnam-destinations-card-map';

export const getArticlesCount = () => {
  const thailandArticlesCount =
    thailandArticlesCardData.length + thailandDestinationsCardData.length;
  const cambodiaArticlesCount =
    cambodiaArticlesCardData.length + cambodiaDestinationsCardData.length;
  const vietnamArticlesCount =
    vietnamArticlesCardData.length + vietnamDestinationsCardData.length;

  return {
    cambodia: cambodiaArticlesCount,
    thailand: thailandArticlesCount,
    vietnam: vietnamArticlesCount,
  };
};
